import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/auth-service.service';
import { RoadmapService } from '../../../pages/info/roadmap/roadmap.service';
import { DatePipe } from '@angular/common';
import { error } from 'console';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by"><b><i class="fa fa-copyright"></i>&nbsp;copyright {{year}} Kenbri |
    <i class="fa fa-envelope"></i>&nbsp;<span><a href="mailto:verkoop&#64;kenbri.nl">verkoop&#64;kenbri.nl</a></span></b></span>
    <span><b><a routerLink="/pages/info/license">{{license}}</a> - <a routerLink="/pages/info/version">{{productVersion}}</a></b></span>
  `,
})
export class FooterComponent implements OnInit {
  //subscription: string;
  productVersion: string;
  license: string;
  year = new Date().getFullYear();
  constructor(private authservice: AuthService, private roadmapService: RoadmapService, private datePipe: DatePipe, private _translateService: TranslateService) {
  }

  ngOnInit(): void {
    this.createLicenseText();
    this._translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.createLicenseText();
    });
  }

  createLicenseText(): void {
    this.license = this._translateService.instant('ALGEMEEN.LICENTIE_ACTIEF');
    var subscriptionExpiresInDays = this.authservice.getSubscriptionExpiresInDays();
    if (subscriptionExpiresInDays == 0) {
      this.license = this._translateService.instant('ALGEMEEN.LICENTIE_VERLOPEN');
    }
    this.roadmapService.getFrontendVersion()
      .subscribe({
        next: version => {
          this.productVersion = this.datePipe.transform(version.ReleaseDate, 'yyyy.MM.dd');
        },
        error: error => {
          this.productVersion = this._translateService.instant('ALGEMEEN.KAN_VERSIE_NIET_OPHALEN');
        }
      });
  }

}